<template>
  <button @click="signIn"><slot></slot></button>
</template>

<script>
  import { gapi, location } from 'window'
  import env from '@/lib/env'

  export default {
    data () {
      return {
        initialized: false
      }
    },
    computed: {
      signInOptions () {
        return {
          client_id: env('GOOGLE_CLIENT_ID'),
          prompt: 'select_account',
          ux_mode: 'redirect',
          redirect_uri: `https://${location.host}/login?google-auth-redirect`
        }
      }
    },
    mounted () {
      gapi.load('auth2', this.onAuth2LibraryLoaded)
    },
    methods: {
      onAuth2LibraryLoaded () {
        gapi.auth2
          .init(this.signInOptions)
          .then(this.onAuthInitSuccess, this.onError)
      },
      onAuthInitSuccess (googleAuth) {
        this.$_googleAuth = googleAuth
        this.initialized = true
        this.checkSignInStatus()
      },
      onError (error) {
        this.$emit('error', error)
      },
      signIn () {
        this.$_googleAuth
          ? this.proceedSignIn()
          : this.$watch('initialized', this.proceedSignIn)
      },
      proceedSignIn () {
        this.$_googleAuth.signIn()
      },
      checkSignInStatus () {
        if (
          this.$route.query.hasOwnProperty('google-auth-redirect') &&
          this.$_googleAuth.isSignedIn.get() === true
        ) {
          const googleUser = this.$_googleAuth.currentUser.get()
          this.onSignInSuccess(googleUser)
        }
      },
      onSignInSuccess (googleUser) {
        const email = googleUser.getBasicProfile().getEmail()
        const token = googleUser.getAuthResponse(true).access_token
        this.$emit('success', { email, token })
      }
    }
  }
</script>




// WEBPACK FOOTER //
// google-sign-in-button.vue?ab9625bc